module.exports = __webpack_public_path__ + "static/Frame-f9fc2b57f3b771703509ede87735217e.jpg";